import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { Popover } from "ui-components/popover/popover";
import XGSNavLink from "ui-components/xgs-nav-link/xgsNavLink";

const columnHelper = createColumnHelper<any>();

export const getOutboundSummaryColumns = (handleViewInboundFreights: (s: any, typeOfFreight: string) => void, handleRedirect: (s: any, d?: any) => void) => [
  columnHelper.accessor("type", {
    id: "type",
    header: "",
    cell: (cellProps) => {
      return <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            fontWeight: 600,
            color: "rgba(79, 95, 114, 0.72)",
            marginRight: 4,
            textAlign: "left",
          }}
        >
          {cellProps.getValue()}
        </div>
        {cellProps.row.original.type === 'ETA Window' && <Popover values={<div>Earliest – Latest expected arrival dates</div>} />}
      </div>
    },
    size: 170,
  }),
  columnHelper.accessor("unassigned", {
    id: "unassigned",
    header: () => <div style={{ textAlign: "left" }}>Unassigned Pickups</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isClickable =
        value !== '-' && cellProps.row.original.type === 'No. of Shipments';

      return (
        isClickable ? <XGSNavLink
          className="xgs-table-link-cell"
          to={`/pickup/outbound/list?d=${cellProps.row.original.terminalDetails.terminalNumber}&s[]=${"UNASSIGNED_PICKUP"}`}
        >
          {value}
        </XGSNavLink> : <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: "default",
            color: "#000",
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("assigned", {
    id: "assigned",
    header: () => <div style={{ textAlign: "left", }}>Assigned Pickups</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isClickable =
        value !== '-' && cellProps.row.original.type === 'No. of Shipments';

      return (
        isClickable ? <XGSNavLink
          className="xgs-table-link-cell"
          to={`/pickup/outbound/list?d=${cellProps.row.original.terminalDetails.terminalNumber}&s[]=${"ASSIGNED_PICKUP"}`}
        >
          {value}
        </XGSNavLink> : <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: "default",
            color: "#000",
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("completed", {
    id: "completed",
    header: () => <div style={{ textAlign: "left" }}>Completed Pickups</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const isClickable =
        value !== '-' && cellProps.row.original.type === 'No. of Shipments';

      return (
        isClickable ? <XGSNavLink
          className="xgs-table-link-cell"
          to={`/pickup/outbound/list?d=${cellProps.row.original.terminalDetails.terminalNumber}&s[]=${"COMPLETED_PICKUP"}`}
        >
          {value}
        </XGSNavLink> : <div
          style={{
            marginRight: 5,
            textAlign: "left",
            cursor: "default",
            color: "#000",
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
  columnHelper.accessor("inhouse", {
    id: "inhouse",
    header: () => <div style={{ textAlign: "left" }}>In-House Freight</div>,
    cell: (cellProps) => {
      const commonClass = "xgs-table-link-cell";
      const value = cellProps.getValue();
      const isEta = cellProps.row.original.type === "ETA Window";
      const isShipments = cellProps.row.original.type === "No. of Shipments";
      const isClickable = value !== "-" && (isEta || isShipments);


      if (isClickable && isShipments) {
        return (
          <XGSNavLink
            className={commonClass}
            to={`/pickup/outbound/list?d=${cellProps.row.original.terminalDetails.terminalNumber}&s[]=${"IN_HOUSE_FREIGHT"}`}
          >
            {value}
          </XGSNavLink>
        );
      }

      if (isClickable && isEta) {
        return (
          <div style={{ cursor: "pointer", color: "#2F80ED" }} onClick={() => handleViewInboundFreights(
            cellProps.row.original,
            "inhouse"
          )
          }> {value}</div >
        );
      }

      return <div>{value}</div>;
    },
    size: 150,
  }),
  columnHelper.accessor("inbound", {
    id: "inbound",
    header: () => <div style={{ textAlign: "left" }}>Inbound Freight</div>,
    cell: (cellProps) => {
      const commonClass = "xgs-table-link-cell";
      const value = cellProps.getValue();
      const isEta = cellProps.row.original.type === "ETA Window";
      const isShipments = cellProps.row.original.type === "No. of Shipments";
      const isClickable = value !== "-" && (isEta || isShipments);


      if (isClickable && isShipments) {
        return (
          <XGSNavLink
            className={commonClass}
            to={`/pickup/outbound/list?d=${cellProps.row.original.terminalDetails.terminalNumber}&s[]=${"INBOUND_FREIGHT"}`}
          >
            {value}
          </XGSNavLink>
        );
      }

      if (isClickable && isEta) {
        return (
          <div style={{ cursor: "pointer", color: "#2F80ED" }} onClick={() => handleViewInboundFreights(
            cellProps.row.original,
            "inbound"
          )
          }> {value}</div >
        );
      }

      return <div>{value}</div>;
    },
    size: 150,
  }),
  columnHelper.accessor("total", {
    id: "total",
    header: () => <div style={{ textAlign: "left" }}>Total</div>,
    cell: (cellProps) => {
      const value = cellProps.getValue();
      return (
        <div
          style={{
            marginRight: 5,
            textAlign: "left",
          }}
        >
          {value}
        </div>
      );
    },
    size: 150,
  }),
];
